export default class JessicaJonesServiceMock {
  accounts = [
    {
      email: 'email@email.com',
      password: 'password',
    },
  ]

  async migrate(email: string, password: string) {
    const account = this.accounts.find((account) => account.email === email)
    if (!account) {
      throw {
        error: 'Bad Request',
        message: 'unregistered_user',
      }
    }
    if (account.password !== password) {
      throw {
        error: 'Bad Request',
        message: 'access_denied',
      }
    }
    return {
      email: account.email,
      password: account.password,
    }
  }
}
